export default __webpack_public_path__ + "static/media/cross.9f423ecc.svg";